import styled from "@emotion/styled";
import { Flex } from "@otrium/core";

const Wrapper = styled(Flex)`
  flex-wrap: wrap;
  justify-content: center;
  & > * {
    margin: ${({ theme }) => theme.space[2]}px 0;
    flex-basis: 46px;
  }
`;

export { Wrapper };
